import { useNeedsIDCheck } from "@/hooks/useNeedsIDCheck";

import { KYCWarning } from "./KYCWarning/KYCWarning";

export const UserWarning = () => {
  const isIDCheck = useNeedsIDCheck();

  return isIDCheck ? <KYCWarning /> : null;
};
